import { Time } from "phaser";
import GameScene from "../scenes/GameScene";
import { GameObject } from "./GameObject";
import { Star } from "./Star";

export class Ramp extends GameObject {
	private arrow?: Phaser.GameObjects.Image;
	trickDirections = ["left", "right", "up"];
	currentDirection: string;
	arrows: Phaser.GameObjects.Image[];
	stars: Star[] = [];
	arrowTimer: Time.TimerEvent | undefined;
	arrowIndex: number;
	constructor(scene: GameScene, x: number, y: number, addArrow: boolean) {
		super(scene);
		const img = this.addImage("ramp");
		img.setScale(0.8);
		this.x = x;
		this.y = y;
		this.currentDirection = this.trickDirections[Phaser.Math.RND.between(0, this.trickDirections.length - 1)];
		this.arrows = [];

		scene.physics.world.enableBody(this, Phaser.Physics.Arcade.STATIC_BODY);
		const body = this.body as Phaser.Physics.Arcade.StaticBody;
		body.setSize(img.displayWidth, img.displayHeight, false);
		const dx = -(body.position.x - this.x);
		const dy = -(body.position.y - this.y);
		body.setOffset(dx - img.displayWidth * 0.3, dy - img.displayHeight / 2);

		let offset = 50;
		if (this.currentDirection == "right") offset = -50;

		const xPos = 250;
		const yPos = -170;
		for (let i = 0; i < 3; i++) {
			const arrow = this.addImage("swipeArrow");
			arrow.setPosition(xPos, yPos);
			this.arrows.push(arrow);
			arrow.setScale(1.1);
			if (this.currentDirection == "up") {
				arrow.setRotation(80);
			}
			if (this.currentDirection == "left") {
				arrow.setScale(-1.1);
			}
			if (i != 0) {
				// if (i == 1) arrow.setAlpha(0.5);
				// else if (i == 2) arrow.setAlpha(0.3);
				if (this.currentDirection == "left" || this.currentDirection == "right") arrow.setPosition(xPos + offset * i, yPos);
				else {
					arrow.setPosition(xPos, yPos + offset * i);
				}
			}
			arrow.alpha = 0;
		}

		if (addArrow) {
			this.arrow = this.addImage("rampArrow");
			this.arrow.setPosition(-80, 0);

			scene.tweens.add({
				targets: this.arrow,
				x: 20,
				ease: Phaser.Math.Easing.Quadratic.Out,
				duration: 1000,
				repeat: -1,
			});
			scene.tweens.add({
				targets: this.arrow,
				y: -100,
				alpha: 0,
				ease: Phaser.Math.Easing.Quadratic.In,
				duration: 1000,
				repeat: -1,
			});
		}
	}
	showArrow(): void {
		let newAlpha = 0;
		for (let i = 0; i < this.arrows.length; i++) {
			if (i == 0) newAlpha = 1;
			else if (i == 1) newAlpha = 0.3;
			else if (i == 2) newAlpha = 0.3;
			this.scene.tweens.add({
				targets: this.arrows[i],
				alpha: newAlpha,
				duration: 50,
				ease: Phaser.Math.Easing.Quadratic.In,
			});
		}
		this.arrowIndex = 2;
		this.arrowTimer = this.scene.time.addEvent({
			delay: 200,
			callback: () => {
				for (let i = 0; i < 3; i++) {
					if (i == this.arrowIndex) this.arrows[i].alpha = 1;
					else this.arrows[i].alpha = 0.3;
				}
				this.arrowIndex--;
				if (this.arrowIndex < 0) this.arrowIndex = 2;
			},
			loop: true,
			callbackScope: this,
		});
	}

	fadeArrow(): void {
		// if (this.arrow && this.scene) {
		// 	this.scene.tweens.killTweensOf(this.arrow);
		// 	this.scene.add.tween({
		// 		targets: this.arrow,
		// 		alpha: 0,
		// 		duration: 400,
		// 		ease: Phaser.Math.Easing.Quadratic.Out,
		// 		onComplete: this.arrow.destroy,
		// 		onCompleteScope: this.arrow,
		// 	});
		// }
		// for (const arrow of this.arrows) {
		// 	this.scene.add.tween({
		// 		targets: arrow,
		// 		alpha: 0,
		// 		duration: 400,
		// 		delay: 2000,
		// 		ease: Phaser.Math.Easing.Quadratic.Out,
		// 		onComplete: () => {
		// 			arrow.destroy();
		// 			//star.onHit();
		// 		},
		// 		onCompleteScope: arrow,
		// 	});
		// }
	}

	destroy(): void {
		if (this.arrowTimer) this.arrowTimer.destroy();
		super.destroy();
	}
}
